import { propertiesOf } from "../utils/propertyOf";

export interface CoinTransfer {
  targetAddress: string;
  coinId: number;
  amount: number | null;
}

export const defaultCoinTransfer: CoinTransfer = {
  targetAddress: "",
  coinId: 1,
  amount: null,
};

export const ofCoinTransfer = propertiesOf<CoinTransfer>();
